






















import { Component, Vue } from 'vue-property-decorator';
import { LanguageModuleMapper } from '@/store/modules/language';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import Icon from '@/components/common/icon.vue';
import Popover from '@/components/common/popover.vue';

import LangSwitcherItem from './langSwitcherItem.vue';
import LangSwitcherFlag from './langSwitcherFlag.vue';

@Component({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'otherLanguages', 'languageTile', 'languagePopular']),
    ...LanguageModuleMapper.mapGetters(['languageListIsLoaded', 'popularLanguage', 'otherLanguage', 'currentLanguage']),
  },
  components: {
    LangSwitcherItem,
    LangSwitcherFlag,
    Icon,
    Popover,
  },
})
export default class LangSwitcherComponent extends Vue {
  isShown = false;

  otherLanguage: any;

  popularLanguage: any;

  get countLanguages() {
    let counter = 0;
    const localArr = this.otherLanguage.filter((column: any) => column.length).concat(this.popularLanguage.filter((column: any) => column.length));
    localArr.forEach(() => {
      counter += 1;
    });
    return counter;
  }
}
